module.exports = require("@mifunstudio/pixi.js");


/*****************
 ** WEBPACK FOOTER
 ** external "@mifunstudio/pixi.js"
 ** module id = 1
 ** module chunks = 0
 **/